import { ReimburseCategory } from "@/types/reimburse";
import { CommonStateEnum } from "@/types/common";

export type ReimburseCategoryNode = Omit<ReimburseCategory, "subs"> & {
  label: string;
  disabled: boolean;
  subs?: ReimburseCategoryNode[];
};

// 递归构建 id 到节点的映射
const buildNodeMap = (nodes: ReimburseCategory[], map: Map<string, ReimburseCategory>) => {
  nodes.forEach(node => {
    map.set(node.id, node);
    if (node.subs && node.subs.length > 0) {
      buildNodeMap(node.subs, map);
    }
  });
};

// 根据路径构建显示文本 (A-B-C)
const buildPathLabel = (node: ReimburseCategory, nodeMap: Map<string, ReimburseCategory>): string => {
  const parts: string[] = [];
  let current: ReimburseCategory | undefined = node;

  // 向上遍历父节点
  while (current) {
    parts.unshift(current.name);
    // 通过 pid 查找父节点
    if (current.pid) {
      current = nodeMap.get(current.pid);
    } else {
      current = undefined;
    }
  }

  return parts.join('-');
};

// 递归构建带路径标签的树数据
const buildTreeDataWithPath = (
  nodes: ReimburseCategory[],
  nodeMap: Map<string, ReimburseCategory>
): ReimburseCategoryNode[] => {
  return nodes.map(node => {
    const label = buildPathLabel(node, nodeMap);
    const result: ReimburseCategoryNode = {
      ...node,
      subs: undefined,
      label,
      disabled: node.state === CommonStateEnum.UN_ACTIVE,
    };
    if (node.subs && node.subs.length > 0) {
      result.subs = buildTreeDataWithPath(node.subs, nodeMap);
    }
    return result;
  });
};

export const prepareReimburseTree = (nodes: ReimburseCategory[]): ReimburseCategoryNode[] => {
  const map = new Map<string, ReimburseCategory>();
  buildNodeMap(nodes, map);
  return buildTreeDataWithPath(nodes, map);
};
